<template>
  <simple-modal v-model="showModal" title="add video" @onClose="closeModal" size="responsive" has-footer :has-button-close="!loadingStashboardMedia">
    <template slot="body">
      <div v-for="error in errors" class="error-banner text-white bg-red mb-5">
        {{error}}
      </div>

      <div class="add-image-modal max-w-xs sm:max-w-xl m-auto">

      <div class="border h-full border-solid rounded-xl mx-1 sm:mx-6 flex flex-col justify-center overflow-hidden">
        <div v-if="!videoSM"
             class="add-image-container flex flex-row items-center justify-center relative px-5">
          <loading-icon v-if='loadingStashboardMedia' class="text-blue"/>
          <template v-else>
            <div class="flex flex-col justify-center items-center w-full">
              <div class="block">
                <button class="sb-button flex flex-col items-center py-1 px-4"
                        @click='fileDialog.click()'>
                  <fai :icon="['fal', 'image']" size="2x"/>
                  upload
                </button>
              </div>
              <p class="m-0 text-4xl pt-3 pb-4">or</p>
              <div class="flex flex-col w-full">
                <p class="m-0">enter youtube video url</p>
                <input class="border border-solid rounded py-2 px-3 bg-white"
                       @input="validateLinkYT"
                       v-model="link"
                       type="text"/>
              </div>
            </div>
          </template>
        </div>
        <div v-else class="video w-full relative overflow-hidden rounded-xl flex items-end justify-center pb-2">
          <iframe
            v-if="videoSM.url"
            id="campaign-video"
            class="absolute top-0 left-0 w-full h-full w-auto h-auto z-0"
            :src="videoSM.url"
          />
          <template v-else>
            <video id="campaign-video"
                  class="absolute top-0 left-0 w-full h-full w-auto h-auto z-0"
                  :src="videoSM.result_url"
                  @ended="onVideoEnded()"/>
            <div class="absolute play-btn top-1/2 left-1/2"
                @click="togglePlayBtn? playVideo(): stopVideo()">
              <svg v-if="togglePlayBtn" aria-hidden="true" focusable="false" data-prefix="far" data-icon="play-circle"
                  class="svg-inline--fa fa-play-circle" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512">
                <path fill="currentColor"
                      d="M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"></path>
              </svg>
              <svg v-else aria-hidden="true" focusable="false" data-prefix="far" data-icon="pause-circle"
                  class="svg-inline--fa fa-pause-circle" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512">
                <path fill="currentColor"
                      d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"></path>
              </svg>
            </div>
          </template>
          
          <div
              class="border border-solid bg-white text-blue rounded py-1 px-4 text-2xl font-normal cursor-pointer relative z-1"
              @click="videoSM = null">remove
          </div>
        </div>
      </div>
      <input
          accept="video/mp4"
          class="hidden"
          ref="file-dialog"
          multiple
          type="file"
          data-cy="photo-upload-input"
          @input="fileChanged"/>
      </div>
    </template>
    <template slot="footer">
      <div class="flex justify-center">
      <button class="sb-button text-base sm:text-xl py-2 px-8 sm:py-4 sm:px-12"
              :disabled="isSubmitDisabled"
              :class="{'sb-disabled': isSubmitDisabled}"
              @click="submit"> Add video
      </button>
      </div>
    </template>
  </simple-modal>
</template>

<script>
import {LoadingIcon} from "@springbig/sb-components";
import SimpleModal from "simple-modal-vue";
import CarouselActions from "./carousel-actions.vue";
import {mapGetters} from "vuex";
import "./very-simple-modal.css";

export default {
  name: "add-video-modal",
  components: {
    SimpleModal,
    LoadingIcon,
    CarouselActions
  },
  props: {
    stashboardMedia: Array
  },
  data() {
    return {
      link: '',
      videoSM: null,
      togglePlayBtn: true,
      errors: [],

      showModal: true
    }
  },
  created() {
    this.videoSM = _.first(this.stashboardMedia)
  },
  methods: {
    async submit() {
      if (this.link) { // if a youtube link is present
        const ytKey = this.validateLinkYT()
        if (!ytKey) {
          this.errors = ['please enter a link from youtube or upload your own video file']
          return
        }
        this.link = '';

        this.videoSM = await this.$store.dispatch('ADD_STASHBOARD_MEDIA', { // create the new yt link media
          url: 'https://www.youtube.com/embed/' + ytKey,
          communication_type: this.videoCommunicationType,
          media_type: 'video'
        })
      }
      this.$store.dispatch('BULK_SAVE_STASHBOARD_MEDIA_FOR_ONE_TYPE', { // resort all the array positions
        stashboardMedia: this.videoSM ? [this.videoSM] : [],
        communication_type: this.videoCommunicationType,
        media_type: "video"
      }).then((medias) => {
        const vid = _.find(medias, (m) => m.media_type == 'video')
        if (vid) this.$store.commit("SET_FOCUSED_STASHBOARD_MEDIA", vid)
        this.closeModal()
      })
    },
    closeModal() {
      this.$emit('update:showModal', false)
    },
    async fileChanged() {
      this.errors = []
      if (this.fileDialog.files?.length > 0) {
        const file = this.fileDialog.files[0]
        const fileSizeMb = file.size / 1024 / 1024;
        this.link = '';
        if (fileSizeMb > 10) {
          this.errors = ['file must be less than 10 mb']
          return
        }
        const result = await this.$store.dispatch('ADD_STASHBOARD_MEDIA', {
          file: file,
          communication_type: this.videoCommunicationType,
          media_type: 'video'
        })
        if (result.errors) {
          this.errors = [result.errors]
        } else {
          this.videoSM = result
        }
        this.fileDialog.value = '';
      }
    },
    validateLinkYT() {
      const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      return (this.link.match(p)) ? RegExp.$1 : false;
    },
    playVideo() {
      const video = document.getElementById('campaign-video')
      if (video) {
        video.play()
        this.togglePlayBtn = false
      }
    },
    stopVideo() {
      const video = document.getElementById('campaign-video')
      if (video) {
        video.pause()
        this.togglePlayBtn = true
      }
    },
    onVideoEnded() {
      const video = document.getElementById('campaign-video')
      if (video) {
        video.currentTime = 0;
        this.togglePlayBtn = true
      }
    }
  },
  computed: {
    fileDialog() {
      return this.$refs['file-dialog']
    },
    isSubmitDisabled() {
      const noVideo = (!this.link && !this.videoSM)
      return this.loadingStashboardMedia ||
        (noVideo && !this.stashboardMedia.length > 0) // make sure there are selections, unless they're trying to deselect everything
    },
    videoCommunicationType() {
      return this.metaDisabledStashboardTabs.length == 0 ? "universal" : this.stashboardCommunicationType
    },
    ...mapGetters([
      'loadingStashboardMedia',
      'stashboardCommunicationType',
      'metaDisabledStashboardTabs'
    ]),
    ...mapGetters({
      owner: "stashboardOwner"
    })
  }
}
</script>

<style scoped>
.video {
  height: 400px;
}
.video video {
  background-size: 100% 100%;
}
.video .play-btn {
  transform: translate(-50%, -50%);
  cursor: pointer;
  transition: all .5s linear;
  opacity: 0;
}
.video .play-btn:hover {
  opacity: 1;
}

.fa-play-circle,
.fa-pause-circle {
  width: 100px;
  height: 100px; }

.fa-play-circle path,
.fa-pause-circle path {
  fill: white; }
</style>